// Hero Slider (custom) — vanilla JS, no external dependencies.
// Each section instance runs independently, so multiple sliders on one page won't conflict.

(function () {
  'use strict';

  function initHeroSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slider-cs__slide'));
    if (slides.length < 2) return;

    var track = root.querySelector('.hero-slider-cs__track');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-slider-cs__dot'));
    var prevBtn = root.querySelector('.hero-slider-cs__arrow--prev');
    var nextBtn = root.querySelector('.hero-slider-cs__arrow--next');

    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var timer = null;

    function goTo(index) {
      var next = (index + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      slides[next].classList.add('is-active');
      if (dots[next]) dots[next].classList.add('is-active');

      current = next;
    }

    function nextSlide() {
      goTo(current + 1);
    }

    function prevSlide() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        nextSlide();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prevSlide();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    // Pause on hover / touch so users can read content
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    // Basic swipe support on touch devices
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? nextSlide() : prevSlide();
      }
      startAutoplay();
    }, { passive: true });

    // Pause when the section scrolls out of view
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.isIntersecting ? startAutoplay() : stopAutoplay();
        });
      }, { threshold: 0.25 });
      observer.observe(root);
    } else {
      startAutoplay();
    }
  }

  function initAll() {
    var sliders = document.querySelectorAll('.hero-slider-cs');
    sliders.forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a new instance is added via the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var newRoot = event.target.querySelector('.hero-slider-cs');
    if (newRoot) initHeroSlider(newRoot);
  });
})();